import clsx from 'clsx';
import type { JSX, ReactNode } from 'react';
import classes from './PageContainer.module.css';

export type PageContainerSize = 'default' | 'chart' | 'narrow';

interface PageContainerProps {
  size?: PageContainerSize;
  fullHeight?: boolean;
  className?: string;
  children: ReactNode;
}

const sizeClass: Record<PageContainerSize, string> = {
  default: classes.default,
  chart: classes.chart,
  narrow: classes.narrow,
};

export function PageContainer({
  size = 'default',
  fullHeight = false,
  className,
  children,
}: PageContainerProps): JSX.Element {
  return (
    <div className={clsx(classes.root, sizeClass[size], fullHeight && classes.fullHeight, className)}>{children}</div>
  );
}
